<!--  -->
<template>
  <div>
    <div class="layout-content" style="background: transparent">
      <div v-if="list.length">
        <Table ref="selection" :columns="columns" :data="list">
          <template slot-scope="{ row }" slot="targetTypeStr">{{
            row.targetTypeStr
          }}</template>
          <template slot-scope="{ row }" slot="targetTypeCount">{{
            row.targetTypeCount
          }}</template>
        </Table>
        <div class="my-page" v-if="totalCount > pageSize" style="margin: 20px; text-align: center">
          <Page show-total show-elevator :page-size="pageSize" :current="pageIndex" :total="totalCount" @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
      <!-- <div class="charts">
          <div ref="chart" :style="{width: '1000px', height: '400px'}"></div>
        </div> -->
    </div>
  </div>
</template>

<script>
import { format } from "echarts";
import { mapActions } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          title: "访问页面",
          slot: "targetTypeStr",
          align: "center",
          //width: 240
        },
        {
          title: "数量",
          slot: "targetTypeCount",
          align: "center",
          //width: 240
        },
      ],
      list: [],
      pageSize: 10,
      pageIndex: 1,
      totalCount: "",
      chartData: [],
    };
  }, 
  created() {
    this.init();
  },
  methods: {
    ...mapActions({
      getPeopleNumber: "hostCommonModule/getPeopleNumber",
    }),
    async init() {
      let opt = {
        pageSize: this.pageSize,
        pageIndex: this.pageIndex,
      };
      let data = await this.getPeopleNumber(opt);
      if (data && data.items && data.items.length > 0) {
        this.list = data.items;
      }
      this.list.forEach((e) => {
        this.chartData.push({
          value: e.targetTypeCount,
          name: e.targetTypeStr,
        });
      });
      // this.canvansChart()
    },

    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    //绘制一个饼图
    // canvansChart(){
    //   let myChart = this.$echarts.init(this.$refs.chart);
    //   myChart.setOption({
    //   series : [
    //     {
    //         name: '访问来源',
    //         type: 'pie',
    //         radius: '55%',
    //         data:this.chartData,
    //         label: {
    //             normal: {
    //             show: true,
    //             formatter: `{b}: {c}({d}%)`
    //            }
    //   }
    //     }
    //   ]
    // })
    // }
  },
};
</script>
<style scoped lang='scss'>
.charts {
  display: flex;
  justify-content: center;
  background: #fff;
  padding-top: 30px;
}
</style>